import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['deleted_at', 'created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                uuid: null,
                course_id: null,
                title: null,
                body: null,
                media: [],
                created_at: null,
                updated_at: null,
                deleted_at: null,
                creator: null,
            };
        },

        getters: {},

        actions: {},

        mutations: {},
    }
);
